import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import { File as UploadedFile } from '../../../../../graphql/generated/graphql';
import _AttachmentUploader from './AttachmentUploader';

interface Props {
  uploadAttachment: (file: File | null) => void;
  uploadingAttachment: boolean;
  uploadedAttachment: UploadedFile | null;
  className?: string;
}

const AttachmentSubmissionForm = ({
  uploadAttachment,
  uploadingAttachment,
  uploadedAttachment,
  className,
}: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>
    <AttachmentUploader
      uploadAttachment={uploadAttachment}
      uploadingAttachment={uploadingAttachment}
      uploadedAttachment={uploadedAttachment}
    />
  </Root>
);

const Root = styled('div')();

const AttachmentUploader = styled(_AttachmentUploader)({
  height: 80,
  width: 450,
});

export default AttachmentSubmissionForm;
